import PortalIdParser from 'PortalIdParser';
import { getUtk } from 'usage-tracker-core/common/defaultTrackers';
export const isRunningInPortal = () => Boolean(PortalIdParser.get());
export const getTrackerType = utk => {
  if (isRunningInPortal()) {
    return 'authed';
  }
  if (utk && utk.length) {
    return 'public';
  }
  return 'anonymous';
};
export const createHstcScheduler = callback => setInterval(() => callback(getUtk()), 200);